export const ROUTES_CONSTANTS = {
  MAIN: "/",
  LOGIN: "/acceso",
  NAVIGATION: "/navigacion",
  DASHBOARD: "/panel",
  USERS: "/usuarios",
  PACKAGES: "/paquetes",
  CLIENTS: "/clientes",
  CLIENTS_DETAILS: "/clientes/:id",
  LOTS: "/recoleccion",
  GUIDES: "/rutas",
  GUIDES_DETAILS: "/rutas/:id",
  DELIVERERS: "/repartidores",
  DELIVERERS_DETAILS: "/repartidores/:id",
  CATEGORIES: "/categorias",
  BALANCES: "/saldos",
  BALANCES_DETAILS: "/saldos/usuario/:id",
  DELIVERY_GUIDES: "/por-entregar",
  REPORT: "/reporte",
  TRACKING: "/rastreo",
  TICKETS: "/tickets",
};